<template>
<div class="animated fadeIn">
    <h2>{{file_path}}</h2>
    <div>
        <button class="btn btn-primary btn-sm btn-mg" @click="loadFile('dev')">Error Log (dev)</button>
        <button class="btn btn-primary btn-sm btn-mg" @click="loadFile('prod')">Error Log (prod)</button>
    </div>
    <pre>{{ file_content }}</pre>
</div>
</template>

<script>
    import { functions } from '@/functions.js';
    import { functions_loaders } from '@/functions_loaders.js';
    import {CONSTANTS} from '@/constants';

    export default {
        name: "NsbAdminFileViewer",
        mixins: [functions, functions_loaders],
        data: function () {
            return {
                file_path:null,
                file_content:null
            }
        },
        methods: {
            loadFile: function (name) {
                this.loadErrorLog(name, function (param, payload) {
                    param.self.file_path = payload.path ;
                    param.self.file_content = payload.data;
                }, {name:name, self:this})
            }
        }
    }
</script>

<style scoped>

</style>
